const sectionSchema = {

  home: {

    // 🔹 1. HERO
    sech1: [
      { key: "heading", label: "Heading", type: "text", maxLength: 45, taggable: true },
      { key: "subheading", label: "Subheading", type: "textarea", maxLength: 160 },
         {
    key: "banners",
    label: "Hero Carousel",
    type: "group",
    repeatable: true,

    fields: [
      { key: "image", label: "Banner Image", type: "image" },

      { key: "alt", label: "Alt Text", type: "text", maxLength: 80 },

      { key: "buttonText", label: "Button Text", type: "text", maxLength: 20 },

      { key: "link", label: "Button Link", type: "text" }
    ]
  }
      // { key: "image", label: "Banner Image", type: "image" }
    ],

    // 🔹 2. BUTTONS
    sech2: [
      { key: "heading", label: "Heading", type: "text", maxLength: 45, taggable: true },

      {
        key: "buttons",
        type: "group",
        repeatable: true,
        limit: 6,
        fields: [
          { key: "text", label: "Button Text", type: "text", maxLength: 30 },
          { key: "link", label: "Link", type: "text" }
        ]
      }
    ],

    // 🔹 3. PRODUCTS (ONLY 2)
    sech3: [
      { key: "heading", type: "text", maxLength: 50, taggable: true },
      { key: "subheading", type: "textarea", maxLength: 120 },

      {
        key: "products",
        type: "group",
        repeatable: true,
        limit: 2,
        fields: [
          { key: "image", type: "image" },
          { key: "imageAlt", type: "text", maxLength: 50 },
          { key: "logo", type: "image" },
          { key: "subtitle", type: "text", maxLength: 50 },

          {
            key: "metrics",
            type: "group",
            repeatable: true,
            limit: 3,
            fields: [
              { key: "value", type: "text", maxLength: 10 },
              { key: "label", type: "text", maxLength: 30 }
            ]
          },

          { key: "statement", type: "text", maxLength: 80 },
          { key: "knowMore", type: "text" },
          { key: "testRide", type: "text" }
        ]
      }
    ],

    // 🔹 4. STATS + VIDEO
    sech4: [
      { key: "heading", type: "text", maxLength: 50, taggable: true },
      { key: "subheading", type: "textarea", maxLength: 120 },

      {
        key: "metrics",
        type: "group",
        repeatable: true,
        limit: 4,
        fields: [
          { key: "value", type: "text" },
          { key: "label", type: "text" },
          { key: "description", type: "textarea", maxLength: 80 }
        ]
      },
      {
        key: "sec4 images",
        type: "group",
        repeatable: true,
        limit: 2,
        fields: [
          { key: "image", type: "image" },
          { key: "imageAlt", type: "text" },
        ]
       },
        { key: "text", label: "Become a Dealer Button Text", type: "text", maxLength: 20 },
        { key: "link", label: "Become a dealer button link", type: "text" }

      // { key: "video", type: "video" },
      // { key: "videoAlt", type: "text" }
    ],

    // 🔹 5. SCROLL TEXT
    sech5: [
      {
        key: "texts",
        type: "group",
        repeatable: true,
        fields: [
          { key: "text", type: "text", maxLength: 40 }
        ]
      }
    ],

    // 🔹 6. IMAGE CARDS
    sech6: [
      { key: "heading", type: "text", taggable: true },

      {
        key: "items",
        type: "group",
        repeatable: true,
        fields: [
          { key: "image", type: "image" },
          { key: "alt", type: "text" },
          { key: "title", type: "text" }
        ]
      }
    ],

    // 🔹 7. TESTIMONIALS
   sech7: [
      { key: "heading", label: "Heading", type: "text", maxLength: 60, taggable: true },

      {
        key: "testimonials",
        label: "Testimonials",
        type: "group",
        repeatable: true,
        fields: [
          {
            key: "contentType",
            label: "Testimonial type",
            type: "select",
            options: [
              { label:"Video", value: "video"},
              { label: "Text", value: "text"}
            ]
          },
         
          {
            key: "video",
            type: "video",
            label: "Video",
            condition: {
              field: "contentType",
              value: "video"
            }
          },
           {
          key: "description",
          type: "textarea",
          label: "Description",
          maxLength: 200,
          condition: {
            field: "contentType",
            value: "text"
          }
        },
         { key: "name", type: "text", label: "Name", maxLength: 40},
          // { key: "video", type: "video" },
          // { key: "name", type: "text" },
          // { key: "description", type: "textarea" }
        ]
      }
    ],

    // 🔹 8
    sech8: [
      { key: "image", type: "image" },
      { key: "heading", type: "text", taggable: true },
      { key: "subheading", type: "textarea" }
    ],

    // 🔹 9 FINANCE
    sech9: [
      { key: "heading", type: "text", taggable: true },
      { key: "subheading", type: "textarea" },
      { key: "description", type: "textarea"},

      {
        key: "banks",
        type: "group",
        repeatable: true,
        fields: [
          { key: "logo", type: "image" },
          { key: "alt", type: "text" }
        ]
      }
    ],

    // 🔹 10
    sech10: [
      { key: "heading", type: "text", taggable: true },
      { key: "description", type: "textarea" },
      { key: "image", type: "image" }
    ],

    // 🔹 11 MERCH
    sech11: [
      { key: "heading", type: "text", taggable: true },
       { key: "subheading", type: "text"},

      {
        key: "items",
        type: "group",
        repeatable: true,
        fields: [
          { key: "image", type: "image" },
          { key: "alt", type: "text" },
          { key: "title", type: "text" },
          { key: "link", type: "text" }
        ]
      },
       { key: "text", label: "Accessories Button Text", type: "text", maxLength: 20 },
       { key: "link", label: "Accessories button link", type: "text" }
    ],

    // 🔹 12 BLOG
    sech12: [
      { key: "heading", type: "text", taggable: true },

      {
        key: "blogs",
        type: "group",
        repeatable: true,
        fields: [
          { key: "image", type: "image" },
          { key: "alt", type: "text" },
          { key: "title", type: "text" },
          { key: "link", type: "text" },
          { key: "date", type: "text" }
        ]
      }
    ],

    // 🔹 13 FAQ
    sech13: [
      {
        key: "faqs",
        type: "group",
        repeatable: true,
        fields: [
          { key: "question", type: "text", taggable: true },
          { key: "answer", type: "textarea", taggable: true }
        ]
      }
    ]

  },
  // Inside sectionSchema, add this alongside "home":

nfirst: {

  // 🔹 1. BANNER
  secn1: [
    { key: "image", label: "Banner Image", type: "image" },
    // { key: "logo", label: "Logo", type: "image" },
    { key: "alt", label: "Image Alt Text", type: "text", maxLength: 80 },
    // { key: "heading", label: "Main heading", type: "text", maxLength: 56}
  ],

  // 🔹 2. PRICE + CITY + METRICS
  secn2: [
    // { key: "heading", label: "Heading", type: "text", maxLength: 45, taggable: true },
    // { key: "subheading", label: "Subheading", type: "textarea", maxLength: 200 },
      { key: "logo", label: "Logo", type: "image" },
       { key: "mainheading", label: "Main heading", type: "text", maxLength: 56, taggable: true},
    { key: "price", label: "Price", type: "text", maxLength: 20 },
    // { key: "buttonText", label: "Button Text", type: "text", maxLength: 20 },
    // { key: "buttonLink", label: "Button Link", type: "text" },

    {
      key: "cities",
      label: "Cities",
      type: "group",
      repeatable: true,
      fields: [
        { key: "name", label: "City Name", type: "text", maxLength: 40 },
        { key: "image", label: "City Image", type: "image" }
      ]
    },

    {
      key: "metrics",
      label: "Metrics",
      type: "group",
      repeatable: true,
      limit: 3,
      fields: [
        { key: "value", label: "Value", type: "text", maxLength: 10 },
        { key: "title", label: "Title", type: "text", maxLength: 30 }
      ]
    },
     { key: "buttonText", label: "Button Text", type: "text", maxLength: 20 },
    { key: "buttonLink", label: "Button Link", type: "text" },
     { key: "heading", label: "Heading", type: "text", maxLength: 45, taggable: true },
    { key: "subheading", label: "Subheading", type: "textarea", maxLength: 200 },
  ],

  // 🔹 3. VIDEO
  secn3: [
    { key: "video", label: "Video", type: "video" },
    { key: "alt", label: "Video Alt Text", type: "text", maxLength: 80 }
  ],

  // 🔹 4. TABS
  secn4: [
    {
      key: "tabs",
      label: "Tab Names",
      type: "group",
      repeatable: false,
      limit: 8,
      fields: [
        { key: "name", label: "Tab Name", type: "text", maxLength: 40 }
      ]
    }
  ],

  // 🔹 5. VIDEO CAROUSEL
  secn5: [
    { key: "heading", label: "Heading", type: "text", maxLength: 112, taggable: true },

    {
      key: "videos",
      label: "Video Carousel",
      type: "group",
      repeatable: true,
      fields: [
        { key: "video", label: "Video", type: "video" },
        { key: "title", label: "Title", type: "text", maxLength: 60 },
        { key: "subtitle", label: "Subtitle", type: "text", maxLength: 125 },
        { key: "alt", label: "Alt Text", type: "text", maxLength: 80 }
      ]
    }
  ],

  // 🔹 6. PHOTO + TEXT
  secn6: [
    { key: "photo", label: "Photo", type: "image" },
    { key: "heading", label: "Heading", type: "text", maxLength: 45, taggable: true },
    { key: "subheading", label: "Subheading", type: "textarea", maxLength: 160 }
  ],

  // 🔹 7. VIDEO CAROUSEL
  secn7: [
    {
      key: "videos",
      label: "Video Carousel",
      type: "group",
      repeatable: true,
      fields: [
        { key: "video", label: "Video", type: "video" },
        { key: "title", label: "Title", type: "text", maxLength: 60 },
        { key: "subtitle", label: "Subtitle", type: "text", maxLength: 100 },
        { key: "alt", label: "Alt Text", type: "text", maxLength: 80 }
      ]
    }
  ],

  // 🔹 8. IMAGE + TEXT
  secn8: [
    { key: "image", label: "Image", type: "image" },
    { key: "alt", label: "Image Alt Text", type: "text", maxLength: 80 },
    { key: "heading", label: "Heading", type: "text", maxLength: 45, taggable: true },
    { key: "subheading", label: "Subheading", type: "textarea", maxLength: 160 }
  ],

  // 🔹 9. SINGLE VIDEO
  secn9: [
    { key: "video", label: "Video", type: "video" },
    { key: "title", label: "Title", type: "text", maxLength: 60 },
    { key: "subtitle", label: "Subtitle", type: "text", maxLength: 100 },
    { key: "alt", label: "Alt Text", type: "text", maxLength: 80 }
  ],

  // 🔹 10. VIDEO CAROUSEL
  secn10: [
    {
      key: "videos",
      label: "Video Carousel",
      type: "group",
      repeatable: true,
      fields: [
        { key: "video", label: "Video", type: "video" },
        { key: "title", label: "Title", type: "text", maxLength: 60 },
        { key: "subtitle", label: "Subtitle", type: "text", maxLength: 100 },
        { key: "alt", label: "Alt Text", type: "text", maxLength: 80 }
      ]
    }
  ],

  // 🔹 11. IMAGE + TEXT
  secn11: [
    { key: "heading", label: "Heading", type: "text", maxLength: 45, taggable: true },
    { key: "subheading", label: "Subheading", type: "textarea", maxLength: 160 },
    { key: "image", label: "Image", type: "image" },
    { key: "alt", label: "Image Alt Text", type: "text", maxLength: 80 }
  ],

  // 🔹 12. VIDEO CAROUSEL
  secn12: [
    {
      key: "videos",
      label: "Video Carousel",
      type: "group",
      repeatable: true,
      fields: [
        { key: "video", label: "Video", type: "video" },
        { key: "title", label: "Title", type: "text", maxLength: 60 },
        { key: "subtitle", label: "Subtitle", type: "text", maxLength: 100 },
        { key: "alt", label: "Alt Text", type: "text", maxLength: 80 }
      ]
    }
  ],

  // 🔹 13. COLOR + IMAGE PICKER
  secn13: [
    {
      key: "colorOptions",
      label: "Color Options",
      type: "group",
      repeatable: true,
      limit: 2,
      fields: [
        { key: "image", label: "Image", type: "image" },
        { key: "color", label: "Color", type: "color" },
        { key: "colorName", label: "Color Name", type: "text", maxLength: 30 }
      ]
    }
  ],

  // 🔹 14. PRODUCT DETAILS (3 variants)
  secn14: [
    {
      key: "products",
      label: "Product Variants",       
      type: "group",
      repeatable: true,
      limit: 3,
      fields: [
        { key: "image", label: "Product Image", type: "image" },
        { key: "variantName", label: "Variant Name", type: "text", maxLength: 40 },
        { key: "price", label: "Price", type: "text", maxLength: 20 },
        { key: "ridingMode", label: "Riding Mode Value", type: "text", maxLength: 30 },
        { key: "batteryCapacity", label: "Battery Capacity Value", type: "text", maxLength: 20 },
        { key: "motorPeakPower", label: "Motor Peak Power Value", type: "text", maxLength: 20 },
        { key: "idcRange", label: "IDC Range Value", type: "text", maxLength: 20 },
        { key: "topSpeed", label: "Top Speed Value", type: "text", maxLength: 20 },
        { key: "groundClearance", label: "Ground Clearance Value", type: "text", maxLength: 20 },

        {
          key: "colors",
          label: "Colors",
          type: "group",
          repeatable: true,
          limit: 2,
          fields: [
            { key: "colorName", label: "Color Name", type: "text", maxLength: 30 },
             { key: "color", label: "Color", type: "color" },
          ]
        },

        // { key: "brochure", label: "Download Brochure (PDF)", type: "file" }
      ]
    },
    { key: "brochure", label: "Download Brochure (PDF)", type: "file" }
  ],

  // 🔹 15. FINANCE / BANKS
  secn15: [
    { key: "heading", label: "Heading", type: "text", maxLength: 45, taggable: true },
    { key: "subheading", label: "Subheading", type: "textarea", maxLength: 160 },
     { key: "description", type: "textarea"},
    { key: "buttonText", label: "Button Text", type: "text", maxLength: 20 },
    { key: "buttonLink", label: "Button Link", type: "text" },

    {
      key: "banks",
      label: "Banks",
      type: "group",
      repeatable: true,
      fields: [
        { key: "logo", label: "Bank Logo", type: "image" },
        { key: "alt", label: "Alt Text", type: "text", maxLength: 80 }
      ]
    }
  ],

  // 🔹 16. HEADING ONLY
  secn16: [
    { key: "heading", label: "Heading", type: "text", maxLength: 45, taggable: true }
  ]

},
dealer: {

  // 🔹 1. HERO
  secd1: [
    { key: "heading", label: "Heading", type: "text", maxLength: 60, taggable: true },
    { key: "subheading", label: "Subheading", type: "textarea", maxLength: 334 },

    {
      key: "banners",
      label: "Hero Carousel",
      type: "group",
      repeatable: true,
      fields: [
        { key: "image", label: "Banner Image", type: "image" },
        { key: "alt", label: "Alt Text", type: "text", maxLength: 80 }
      ]
    }
  ],

  // 🔹 2. GROUND UP
  secd2: [
    { key: "heading", label: "Heading", type: "text", maxLength: 60, taggable: true },
    { key: "subheading", label: "Subheading", type: "textarea", maxLength: 200 },

    {
      key: "metrics",
      label: "Metrics",
      type: "group",
      repeatable: true,
      limit: 4,
      fields: [
        { key: "value", type: "text", maxLength: 20 },
        { key: "label", type: "text", maxLength: 40 },
        { key: "description", type: "textarea", maxLength: 120 }
      ]
    },

    { key: "video", label: "Video", type: "video" },
    { key: "alt", label: "Video Alt Text", type: "text", maxLength: 80 },

    { key: "buttonText", label: "Button Text", type: "text", maxLength: 30 },
    { key: "buttonLink", label: "Button Link", type: "text" }
  ],

  // 🔹 3. WHY PARTNERS
  secd3: [
    { key: "heading", label: "Heading", type: "text", maxLength: 60, taggable: true },
    { key: "subheading", label: "Subheading", type: "textarea", maxLength: 200 },

    {
      key: "cards",
      label: "Image Carousel",
      type: "group",
      repeatable: true,
      fields: [
        { key: "image", type: "image" },
        { key: "alt", type: "text", maxLength: 80 },
        { key: "title", type: "text", maxLength: 50 },
        { key: "description", type: "textarea", maxLength: 120 }
      ]
    },

    { key: "buttonText", type: "text", maxLength: 50 },
    { key: "buttonLink", type: "text" },

    {
      key: "cities",
      label: "City Names",
      type: "group",
      repeatable: true,
      fields: [
       { key: "name", label: "City Name", type: "text", maxLength: 40 },
        { key: "statename", label: "State Name", type: "text", maxLength: 40}
      ]
    }
  ],

  // 🔹 4. DEALERSHIP (TABS + TABLES)
  secd4: [
    { key: "heading", label: "Heading", type: "text", maxLength: 60, taggable: true },

    /**
     * DEALER TAB
     */
    {
      key: "dealer",
      label: "Dealer Tab",
      type: "group",
      repeatable: false,
      limit: 1,
      fields: [

        // Investment Table (7 rows recommended)
        {
          key: "investment",
          label: "Investment Table",
          type: "group",
          repeatable: true,
          fields: [
            { key: "label", type: "text", maxLength: 50 },
            { key: "value", type: "text", maxLength: 30 }
          ]
        },

        // Area Table (4 rows)
        {
          key: "area",
          label: "Area Requirement",
          type: "group",
          repeatable: true,
          fields: [
            { key: "label", type: "text", maxLength: 50 },
            { key: "value", type: "text", maxLength: 30 }
          ]
        },

        // Manpower
        {
          key: "sales",
          label: "Sales Positions",
          type: "group",
          repeatable: true,
          fields: [
            { key: "role", type: "text", maxLength: 40 },
            { key: "count", type: "text", maxLength: 10 }
          ]
        },
        {
          key: "service",
          label: "Service Positions",
          type: "group",
          repeatable: true,
          fields: [
            { key: "role", type: "text", maxLength: 40 },
            { key: "count", type: "text", maxLength: 10 }
          ]
        },
        {
          key: "spares",
          label: "Spares Positions",
          type: "group",
          repeatable: true,
          fields: [
            { key: "role", type: "text", maxLength: 40 },
            { key: "count", type: "text", maxLength: 10 }
          ]
        }
      ]
    },

    /**
     * SUBDEALER TAB (same structure)
     */
    {
      key: "subdealer",
      label: "Subdealer Tab",
      type: "group",
      repeatable: false,
      limit: 1,
      fields: [

        {
          key: "investment",
          type: "group",
          repeatable: true,
          fields: [
            { key: "label", type: "text" },
            { key: "value", type: "text" }
          ]
        },

        {
          key: "area",
          type: "group",
          repeatable: true,
          fields: [
            { key: "label", type: "text" },
            { key: "value", type: "text" }
          ]
        },

        {
          key: "sales",
          type: "group",
          repeatable: true,
          fields: [
            { key: "role", type: "text" },
            { key: "count", type: "text" }
          ]
        },
        {
          key: "Service and Spares",
          type: "group",
          repeatable: true,
          fields: [
            { key: "role", type: "text" },
            { key: "count", type: "text" }
          ]
        },
       
      ]
    }
  ],

  // 🔹 5. FORM SECTION
  secd5: [
    { key: "heading", label: "Heading", type: "text", maxLength: 60, taggable: true }
  ]

},

locateDealer: {
  // 1. HERO Section1
  secl1: [
    { key: "image", label: "Banner Image", type: "image" },
    { key: "alt", label: "Image Alt Text", type: "text", maxLength: 90 },

    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 50,
      taggable: true
    },
    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 110
    },
     {
      key: "selectCity",
      label: "Select City Text",
      type: "text",
      //maxLength: 23
    }
  ],

  // 2. DEALERS (UPDATED)
  secl2: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      //maxLength: 50,
      taggable: true
    },
  ],

  // 3. ACCESSORIES (UNCHANGED)
  secl3: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 60,
      taggable: true
    },
    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 140
    },

    {
      key: "accessories",
      label: "Accessories",
      type: "group",
      repeatable: true,
      fields: [
        { key: "image", label: "Image", type: "image" },
        { key: "alt", label: "Alt Text", type: "text", maxLength: 80 },
        { key: "title", label: "Title", type: "text", maxLength: 30 },
        { key: "ctaText", label: "CTA Text", type: "text", maxLength: 25 },
        { key: "ctaLink", label: "CTA Link", type: "text" }
      ]
    },

    { key: "buttonText", label: "Button Text", type: "text", maxLength: 25 },
    { key: "buttonLink", label: "Button Link", type: "text" }
  ],

  //  4. SPACE SECTION (UNCHANGED)
  secl4: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 50,
      taggable: true
    },

    {
      key: "spaces",
      label: "Space Cards",
      type: "group",
      repeatable: true,
      limit: 4,
      fields: [
        { key: "image", label: "Image", type: "image" },
        { key: "alt", label: "Alt Text", type: "text", maxLength: 80 },
        { key: "caption", label: "Caption", type: "text", maxLength: 60 }
      ]
    }
  ],

  //5. FAQ SECTION 
   secl5: [
      {
        key: "faqs",
        type: "group",
        repeatable: true,
        fields: [
          { key: "question", type: "text", taggable: true },
          { key: "answer", type: "textarea", taggable: true }
        ]
      }
    ],

    //6. Scooter Catalog
    secl6: [
       {
      key: "variantsheading",
      label: "Variant Details Heading",
      type: "text",
      maxLength: 30,
      taggable: true
    },
    ],

  // 7. OWNERSHIP SECTION 
  secl7: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 60,
      taggable: true
    },

    {
      key: "ownershipCards",
      label: "Ownership Cards",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "image",
          label: "Card Image",
          type: "image"
        },
        {
          key: "alt",
          label: "Image Alt Text",
          type: "text",
          maxLength: 80
        },
        {
          key: "title",
          label: "Title",
          type: "text",
          maxLength: 40
        },
       
      ]
    }
  ]

}, 
privacyPolicy: {
 
  // 🔹 1. PAGE INTRO
  secpp1: [
    { key: "pageTitle", label: "Page Title", type: "text", maxLength: 60, taggable: true },
 
    // Admin can keep adding paragraphs to the intro block
    {
      key: "paragraphs",
      label: "Intro Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 400 }
      ]
    },
 
    { key: "termsLinkText", label: "Terms Link Text", type: "text", maxLength: 60 },
    { key: "termsLinkUrl", label: "Terms Link URL", type: "text" },
    { key: "searchPlaceholder", label: "Search Placeholder Text", type: "text", maxLength: 40 }
  ],
 
  // 🔹 2. INTERPRETATION & DEFINITIONS
  secpp2: [
    { key: "sectionHeading", label: "Section Heading", type: "text", maxLength: 60, taggable: true },
 
    // Interpretation sub-section
    { key: "interpretationHeading", label: "Interpretation Sub-Heading", type: "text", maxLength: 60, taggable: true },
 
    {
      key: "interpretationParagraphs",
      label: "Interpretation Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 400 }
      ]
    },
 
    // Definitions sub-section
    { key: "definitionsHeading", label: "Definitions Sub-Heading", type: "text", maxLength: 60, taggable: true },
 
    {
      key: "definitionsIntroParagraphs",
      label: "Definitions Intro Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 300 }
      ]
    },
 
    // Each definition term + its text
    {
      key: "definitions",
      label: "Definition Items",
      type: "group",
      repeatable: true,
      fields: [
        { key: "term", label: "Term / Word", type: "text", maxLength: 60 },
        { key: "definition", label: "Definition Text", type: "textarea", maxLength: 400 }
      ]
    }
  ],
 
  // 🔹 3. COLLECTING & USING YOUR PERSONAL DATA
  secpp3: [
    { key: "sectionHeading", label: "Section Heading", type: "text", maxLength: 80, taggable: true },
    { key: "typesHeading", label: "Types of Data Heading", type: "text", maxLength: 60, taggable: true },
 
    // Personal Data sub-section
    { key: "personalDataHeading", label: "Personal Data Sub-Heading", type: "text", maxLength: 60, taggable: true },
 
    {
      key: "personalDataIntroParagraphs",
      label: "Personal Data Intro Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 400 }
      ]
    },
 
    { key: "personalDataListIntro", label: "Personal Data List Intro", type: "text", maxLength: 100 },
 
    {
      key: "personalDataItems",
      label: "Personal Data List Items",
      type: "group",
      repeatable: true,
      fields: [
        { key: "item", label: "Data Item", type: "text", maxLength: 60 }
      ]
    },
 
    // Usage Data sub-section
    { key: "usageDataHeading", label: "Usage Data Sub-Heading", type: "text", maxLength: 60, taggable: true },
 
    {
      key: "usageDataParagraphs",
      label: "Usage Data Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 500 }
      ]
    }
  ],
 
  // 🔹 4. TRACKING TECHNOLOGIES & COOKIES
  secpp4: [
    { key: "sectionHeading", label: "Section Heading", type: "text", maxLength: 80, taggable: true },
 
    {
      key: "introParagraphs",
      label: "Intro Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 400 }
      ]
    },
 
    
 
    {
      key: "trackingTechnologies",
      label: "Tracking Technologies",
      type: "group",
      repeatable: true,
      fields: [
        { key: "name", label: "Technology Name", type: "text", maxLength: 60 },
        { key: "description", label: "Description", type: "textarea", maxLength: 500 }
      ]
    },
 
    {
      key: "cookieTypesParagraphs",
      label: "Persistent vs Session Cookies Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 400 }
      ]
    },
 
    { key: "cookieUsageIntro", label: "Cookie Usage Intro", type: "text", maxLength: 150 },
 
    // Each cookie type block (Necessary, Notice Acceptance, Functionality, etc.)
    {
      key: "cookieTypes",
      label: "Cookie Types",
      type: "group",
      repeatable: true,
      fields: [
        { key: "name", label: "Cookie Name", type: "text", maxLength: 80 },
        { key: "typeLabel", label: "Type Label", type: "text", maxLength: 20 },
        { key: "typeValue", label: "Type Value", type: "text", maxLength: 40 },
        { key: "administeredByLabel", label: "Administered By Label", type: "text", maxLength: 30 },
        { key: "administeredByValue", label: "Administered By Value", type: "text", maxLength: 40 },
        { key: "purposeLabel", label: "Purpose Label", type: "text", maxLength: 20 },
        { key: "purposeText", label: "Purpose Text", type: "textarea", maxLength: 400 }
      ]
    }
  ],
 
  // 🔹 5. USE OF YOUR PERSONAL DATA
  secpp5: [
    { key: "sectionHeading", label: "Section Heading", type: "text", maxLength: 80, taggable: true },
 
    {
      key: "usageIntroParagraphs",
      label: "Usage Intro Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 300 }
      ]
    },
 
    // Admin can add more usage purposes
    {
      key: "usagePurposes",
      label: "Usage Purposes",
      type: "group",
      repeatable: true,
      fields: [
        { key: "title", label: "Purpose Title", type: "text", maxLength: 80 },
        { key: "description", label: "Purpose Description", type: "textarea", maxLength: 400 }
      ]
    },
 
    {
      key: "sharingIntroParagraphs",
      label: "Sharing Intro Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
         { key: "title", label: "Other Purpose Label", type: "text", maxLength: 100 },
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 500 },
         {
      key: "sharingSituations",
      label: "Sharing Situations",
      type: "group",
      repeatable: true,
      fields: [
        { key: "title", label: "Situation Title", type: "text", maxLength: 80 },
        { key: "description", label: "Situation Description", type: "textarea", maxLength: 400 }
      ]
    }
      ]
    },
 
    // Admin can add more sharing situations
    // {
    //   key: "sharingSituations",
    //   label: "Sharing Situations",
    //   type: "group",
    //   repeatable: true,
    //   fields: [
    //     { key: "title", label: "Situation Title", type: "text", maxLength: 80 },
    //     { key: "description", label: "Situation Description", type: "textarea", maxLength: 400 }
    //   ]
    // }
  ],
 
  // 🔹 6. RETENTION OF YOUR PERSONAL DATA
  secpp6: [
    { key: "sectionHeading", label: "Section Heading", type: "text", maxLength: 80, taggable: true },
 
    // Admin can add more retention paragraphs freely
    {
      key: "paragraphs",
      label: "Retention Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 600 }
      ]
    }
  ],
 
  // 🔹 7. TRANSFER OF YOUR PERSONAL DATA
  secpp7: [
    { key: "sectionHeading", label: "Section Heading", type: "text", maxLength: 80, taggable: true },
 
    // Admin can add more transfer paragraphs freely
    {
      key: "paragraphs",
      label: "Transfer Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 600 }
      ]
    }
  ],
 
  // 🔹 8. YOUR ACCESS TO YOUR PERSONAL DATA
  secpp8: [
    { key: "sectionHeading", label: "Section Heading", type: "text", maxLength: 80, taggable: true },
 
    // All body paragraphs are now a single repeatable group —
    // admin can add, remove, or reorder paragraphs freely
    // (covers: delete rights, in-app deletion, update/contact note,
    //  legal obligation note, consent withdrawal paras, etc.)
    {
      key: "paragraphs",
      label: "Access Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 600 }
      ]
    },
 
    // Contact email kept separate so it renders as a mailto link
    { key: "contactEmail", label: "Contact Email Address", type: "text", maxLength: 80 }
  ],
 
  // 🔹 9. DISCLOSURE OF YOUR PERSONAL DATA
  // Fully dynamic: admin can add any number of named sub-sections
  // (e.g. Law Enforcement, Security, Children's Privacy, or brand-new ones),
  // and each sub-section can hold any number of paragraphs.
  secpp9: [
    { key: "sectionHeading", label: "Section Heading", type: "text", maxLength: 80, taggable: true },
 
    {
      key: "subSections",
      label: "Disclosure Sub-Sections",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "subHeading",
          label: "Sub-Section Heading",
          type: "text",
          maxLength: 80,
          taggable: true
        },
        {
          key: "paragraphs",
          label: "Sub-Section Paragraphs",
          type: "group",
          repeatable: true,
          fields: [
            { key: "text", label: "Paragraph Text", type: "textarea"}
          ]
        }
      ]
    }
  ],
 
  // 🔹 10. LINKS TO OTHER WEBSITES
  secpp10: [
    { key: "sectionHeading", label: "Section Heading", type: "text", maxLength: 80, taggable: true },
 
    // Admin can add more paragraphs freely
    {
      key: "paragraphs",
      label: "Links Section Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 400 }
      ]
    }
  ],
 
  // 🔹 11. CHANGES TO PRIVACY POLICY
  secpp11: [
    { key: "sectionHeading", label: "Section Heading", type: "text", maxLength: 80, taggable: true },
 
    // Admin can add more paragraphs freely
    {
      key: "paragraphs",
      label: "Changes Section Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 400 }
      ]
    }
  ],
 
  // 🔹 12. CONTACT US
  secpp12: [
    { key: "sectionHeading", label: "Section Heading", type: "text", maxLength: 60, taggable: true },
 
    // Intro paragraphs before the officer details
    {
      key: "introParagraphs",
      label: "Contact Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 400 }
      ]
    },
 
    // { key: "grievanceOfficerLabel", label: "Grievance Officer Label", type: "text", maxLength: 60 },
    // { key: "grievanceOfficerName", label: "Grievance Officer Name", type: "text", maxLength: 80 },
    // { key: "contactEmail", label: "Contact Email Address", type: "text", maxLength: 80 },
 
    // // Any additional paragraphs after the officer details (e.g. response time note)
    // {
    //   key: "closingParagraphs",
    //   label: "Closing Paragraphs",
    //   type: "group",
    //   repeatable: true,
    //   fields: [
    //     { key: "text", label: "Paragraph Text", type: "textarea", maxLength: 400 }
    //   ]
    // }
  ],
 
  // 🔹 13. LAST UPDATED (Footer note)
  secpp13: [
    { key: "lastUpdatedLabel", label: "Last Updated Statement", type: "text", maxLength: 100 },
   
  ]
 
}, 
refundPolicy: {

  // 1. HEADER + INTRO PARAGRAPHS
  secr1: [
    {
      key: "heading",
      label: "Main Heading",
      type: "text",
      maxLength: 80,
      taggable: true
    },

    {
      key: "paras",
      label: "Intro Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "text",
          label: "Paragraph",
          type: "textarea",
          maxLength: 500
        }
      ]
    }
  ],

  // 2. POINTS SECTION (MAIN POLICY BLOCKS)
  secr2: [
    {
      key: "items",
      label: "Policy Sections",
      type: "group",
      repeatable: true,
      fields: [

        {
          key: "heading",
          label: "Section Heading",
          type: "text",
          maxLength: 100,
          taggable: true
        },

        {
          key: "statement",
          label: "Statement",
          type: "textarea",
          maxLength: 400
        },

        {
          key: "points",
          label: "Points",
          type: "group",
          repeatable: true,
          fields: [
            {
              key: "text",
              label: "Point",
              type: "textarea",
              maxLength: 300
            }
          ]
        }
      ]
    }
  ],

  // 3. SHIPPING SECTION
  secr3: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 80,
      taggable: true
    },
    {
      key: "paras",
      label: "Shipping Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "text",
          label: "Paragraph",
          type: "textarea",
          maxLength: 400
        }
      ]
    }
  ],

  // 4. CUSTOMER RESPONSIBILITIES
  secr4: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 80,
      taggable: true
    },

    {
      key: "statement",
      label: "Statement",
      type: "textarea",
      maxLength: 300
    },

    {
      key: "points",
      label: "Responsibilities Points",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "text",
          label: "Point",
          type: "textarea",
          maxLength: 250
        }
      ]
    }
  ],

  // 5. CONTACT US
  secr5: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 80,
      taggable: true
    },

    {
      key: "paras",
      label: "Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "text",
          label: "Paragraph",
          type: "textarea",
          maxLength: 300
        }
      ]
    }
  ],

  // 6. FINAL SECTION (CHANGES / DISCLAIMER)
  secr6: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 80,
      taggable: true
    },

    {
      key: "points",
      label: "Final Points",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "text",
          label: "Point",
          type: "textarea",
          maxLength: 300
        }
      ]
    }
  ],
  secr7: [
  {
    key: "text",
    label: "Thank You Statement",
    type: "textarea",
    maxLength: 180
  }
]

},

termsConditions: {

  // 🔹 1. HEADER + INTRO
  sect1: [
    {
      key: "heading",
      label: "Main Heading",
      type: "text",
      maxLength: 80,
      taggable: true
    },

    {
      key: "paras",
      label: "Intro Paragraphs",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "text",
          label: "Paragraph",
          type: "textarea",
          maxLength: 500
        }
      ]
    }
  ],

  // 🔹 2. INTERPRETATION + DEFINITIONS (IMPORTANT)
  sect2: [
    {
      key: "heading",
      label: "Section Heading",
      type: "text",
      maxLength: 100,
      taggable: true
    },

    {
      key: "statement",
      label: "Statement",
      type: "textarea",
      maxLength: 400
    },

    {
      key: "definitions",
      label: "Definitions",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "term",
          label: "Term",
          type: "text",
          maxLength: 60
        },
        {
          key: "meaning",
          label: "Meaning",
          type: "textarea",
          maxLength: 400
        }
      ]
    }
  ],

  // 🔹 3. GENERAL SECTIONS (ACKNOWLEDGEMENT, LINKS, TERMINATION, ETC.)
  sect3: [
    {
      key: "sections",
      label: "Content Sections",
      type: "group",
      repeatable: true,
      fields: [

        {
          key: "heading",
          label: "Section Heading",
          type: "text",
          maxLength: 100,
          taggable: true
        },

        {
          key: "paras",
          label: "Paragraphs",
          type: "group",
          repeatable: true,
          fields: [
            {
              key: "text",
              label: "Paragraph",
              type: "textarea",
              maxLength: 600
            }
          ]
        }
      ]
    }
  ],

  // 🔹 4. BULLET / LEGAL POINT SECTIONS (LIABILITY, DISCLAIMER, ETC.)
  sect4: [
  {
    key: "sections",
    label: "Legal Sections",
    type: "group",
    repeatable: true,
    fields: [
      {
        key: "heading",
        label: "Section Heading",
        type: "text",
        maxLength: 100,
        taggable: true
      },
      {
        key: "paras",
        label: "Paragraphs",
        type: "group",
        repeatable: true,
        fields: [
          {
            key: "text",
            label: "Paragraph",
            type: "textarea"
            // ✅ NO maxLength (legal safe)
          }
        ]
      }
    ]
  }
],

  // 🔹 5. GOVERNING / DISPUTES / WAIVER TYPE
 sect5: [
  {
    key: "heading",
    label: "Main Heading",
    type: "text",
    maxLength: 100,
    taggable: true
  },

  {
    key: "subsections",
    label: "Sub Sections",
    type: "group",
    repeatable: true,
    fields: [
      {
        key: "subheading",
        label: "Sub Heading",
        type: "text",
        maxLength: 80,
        taggable: true
      },
      {
        key: "paras",
        label: "Paragraphs",
        type: "group",
        repeatable: true,
        fields: [
          {
            key: "text",
            label: "Paragraph",
            type: "textarea"
          }
        ]
      }
    ]
  }
],

  // 🔹 6. FINAL SECTIONS
//   sect6: [
//   {
//     key: "sections",
//     label: "Final Sections",
//     type: "group",
//     repeatable: true,
//     fields: [
//       {
//         key: "heading",
//         label: "Heading",
//         type: "text",
//         maxLength: 100,
//         taggable: true
//       },
//       {
//         key: "paras",
//         label: "Paragraphs",
//         type: "group",
//         repeatable: true,
//         fields: [
//           {
//             key: "text",
//             label: "Paragraph",
//             type: "textarea"
//           }
//         ]
//       }
//     ]
//   }
// ],

 sect6: [
  {
    key: "sections",
    label: "Translation and Changes to T&C",
    type: "group",
    repeatable: true,
    fields: [
      {
        key: "heading",
        label: "Section Heading",
        type: "text",
        maxLength: 100,
        taggable: true
      },
      {
        key: "paras",
        label: "Paragraphs",
        type: "group",
        repeatable: true,
        fields: [
          {
            key: "text",
            label: "Paragraph",
            type: "textarea"
            // ✅ NO maxLength (legal safe)
          }
        ]
      }
    ]
  }
],

// 🔹 8. CONTACT US
sect7: [
  {
    key: "heading",
    label: "Heading",
    type: "text",
    maxLength: 60,
    taggable: true
  },
  {
    key: "email",
    label: "Email",
    type: "text",
    maxLength: 100
  },
  {
    key: "link",
    label: "Contact Page Link",
    type: "text"
  }
]

},
contactUs: {

  // 🔹 1. FORM HEADER (FORM STATIC)
  secc1: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 50,
      taggable: true
    },
    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 100
    }
  ],

  // 🔹 2. OTHER WAYS TO CONNECT
  secc2: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 50,
      taggable: true
    },
    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 80
    },

    {
      key: "email",
      label: "Email",
      type: "text",
      maxLength: 100
    },
    {
      key: "phone",
      label: "Phone Number",
      type: "text",
      maxLength: 20
    },
    {
      key: "tollFree",
      label: "Toll Free Number",
      type: "text",
      maxLength: 20
    }
  ],

  // 🔹 3. LOCATIONS / FIND US
  secc3: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 50,
      taggable: true
    },
    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 100
    },

    {
      key: "locations",
      label: "Locations",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "image",
          label: "Location Image",
          type: "image"
        },
        {
          key: "alt",
          label: "Image Alt Text",
          type: "text",
          maxLength: 80
        },
        {
          key: "name",
          label: "Location Name",
          type: "text",
          maxLength: 50
        },
        {
          key: "address",
          label: "Address",
          type: "textarea",
          maxLength: 180
        },
        {
          key: "directionsLink",
          label: "Get Directions Link",
          type: "text"
        }
      ]
    }
  ]

},
careers: {

  // 🔹 1. HERO SECTION
  seccr1: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 60,
      taggable: true
    },
    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 300
    },
    {
      key: "buttonText",
      label: "Button Text",
      type: "text",
      maxLength: 25
    },
    {
      key: "buttonLink",
      label: "Button Link",
      type: "text"
    },
    {
      key: "images",
      label: "Images",
      type: "group",
      repeatable: true,
      limit: 4,
      fields: [
        { key: "image", type: "image", label: "Image" },
        { key: "alt", type: "text", label: "Alt Text", maxLength: 80 }
      ]
    }
  ],

  

  // 2. BUILT FOR INDIA SECTION
  seccr2: [
    {
      key: "heading",
      type: "text",
      label: "Heading",
      maxLength: 60,
      taggable: true
    },
    {
      key: "subheading",
      type: "textarea",
      label: "Subheading",
      maxLength: 200
    },

    {
      key: "points",
      label: "Points",
      type: "group",
      repeatable: true,
      limit: 4,
      fields: [
        { key: "text", type: "text", label: "Point", maxLength: 40 }
      ]
    },

    {
      key: "image",
      type: "image",
      label: "Side Image"
    },
    {
      key: "alt",
      type: "text",
      label: "Image Alt",
      maxLength: 80
    }
  ],

  // 3. VALUES (i-SCALE)
  seccr3: [
      {
      key: "image",
      type: "image",
      label: "Side Image"
    },
    {
      key: "alt",
      type: "text",
      label: "Image Alt",
      maxLength: 80
    },
    {
      key: "heading",
      type: "text",
      label: "Heading",
      maxLength: 60,
      taggable: true
    },
    {
      key: "subheading",
      type: "textarea",
      label: "Subheading",
      maxLength: 200
    },
    {
      key: "values",
      label: "Values",
      type: "group",
      repeatable: true,
      limit: 6,
      fields: [
       
        { key: "title", type: "text", label: "Title", maxLength: 40 },
        { key: "description", type: "textarea", label: "Description", maxLength: 120 }
      ]
    }
  ],

  // 4. MID IMAGE BANNER
  seccr4: [
    { key: "image", type: "image", label: "Banner Image" },
    { key: "alt", type: "text", label: "Alt Text", maxLength: 80 }
  ],

  // 5. EMPLOYEE BENEFITS
  seccr5: [
    {
      key: "heading",
      type: "text",
      label: "Heading",
      maxLength: 60,
      taggable: true
    },
    {
      key: "subheading",
      type: "textarea",
      label: "Subheading",
      maxLength: 250
    },

    {
      key: "cards",
      label: "Benefit Cards",
      type: "group",
      repeatable: true,
      limit: 3,
      fields: [
        { key: "title", type: "text", label: "Title", maxLength: 40 },

        {
          key: "points",
          type: "group",
          label: "Points",
          repeatable: true,
          fields: [
            { key: "text", type: "text", label: "Point", maxLength: 60 }
          ]
        }
      ]
    }
  ],

  // 6. OPEN ROLES
  seccr6: [
    {
      key: "heading",
      type: "text",
      label: "Heading",
      maxLength: 50,
      taggable: true
    },
    {
      key: "subheading",
      type: "textarea",
      label: "Subheading",
      maxLength: 150
    },
  ]

},
testRide: {

  // 🔹 1. HERO SECTION
  sectr1: [
    {
      key: "hero banner",
      label: "Hero Banner",
      type:"image",
    },
     {
      key: "image alt text",
      label: "Image alt text",
      type: "text",
      
    },
    {
      key: "heading",
      label: "Main Heading",
      type: "text",
      maxLength: 80,
      taggable: true
    },
  ],

  // 🔹 2. BOOK TEST RIDE SECTION (ALL LABEL TEXTS)
  sectr2: [

    {
      key: "heading",
      label: "Section Heading (Book a Test Ride)",
      type: "text",
      maxLength: 40,
      taggable: true
    },

    // Variant text (dynamic options come from DB)
    {
      key: "variantLabel",
      label: "Variant Section Label",
      type: "text",
      maxLength: 120
    },
    {
      key: "variantNote",
      label: "Variant Note",
      type: "textarea",
      maxLength: 180
    },

    // City selector
    {
      key: "cityLabel",
      label: "City Label",
      type: "text",
      maxLength: 40
    },
   
    // Test ride type
    {
      key: "rideTypeHeading",
      label: "Ride Type Heading",
      type: "text",
      maxLength: 80,
      taggable: true
    },
    {
      key: "homeRideText",
      label: "Home Test Ride Text",
      type: "text",
      maxLength: 40
    },
    {
      key: "showroomRideText",
      label: "Visit Showroom Text",
      type: "text",
      maxLength: 40
    },

    // Showroom
    {
      key: "showroomHeading",
      label: "Preferred Showroom Heading",
      type: "text",
      maxLength: 60,
      taggable: true
    },
    {
      key: "directionsText",
      label: "Get Directions Text",
      type: "text",
      maxLength: 30
    },

    // Date section
    {
      key: "dateHeading",
      label: "Pick Date Heading",
      type: "text",
      maxLength: 40,
      taggable: true
    },
    {
      key: "timingNote",
      label: "Timing Note",
      type: "textarea",
      maxLength: 120
    }

  ],

  // 🔹 3. PERSONAL INFORMATION SECTION
  sectr3: [
    {
      key: "heading",
      label: "Personal Info Heading",
      type: "text",
      maxLength: 60,
      taggable: true
    },

    {
      key: "nameLabel",
      label: "Full Name Label",
      type: "text",
      maxLength: 30
    },
    {
      key: "phoneLabel",
      label: "Phone Label",
      type: "text",
      maxLength: 30
    },
    {
      key: "phoneNote",
      label: "Phone Helper Text",
      type: "textarea",
      maxLength: 120
    },
    {
      key: "emailLabel",
      label: "Email Label",
      type: "text",
      maxLength: 30
    },

    {
      key: "consentText",
      label: "Consent / Disclaimer Text",
      type: "textarea",
      maxLength: 300
    }
  ],

 sectr4: [

  // ✅ SUCCESS MESSAGE
  {
    key: "heading",
    label: "Success Heading",
    type: "text",
    maxLength: 80,
    taggable: true
  },
  {
    key: "subtext",
    label: "Subtext (License Note)",
    type: "textarea",
    maxLength: 120
  },

  // ✅ BROCHURES (NOW REPEATABLE ✅)
  {
    key: "brochures",
    label: "Brochures",
    type: "group",
    repeatable: true,
    limit: 3,
    fields: [
      {
        key: "text",
        label: "Brochure Text (e.g. n-First brochure)",
        type: "text",
        maxLength: 40
      },
      {
        key: "file",
        label: "Brochure PDF",
        type: "file"
      }
    ]
  },

  // ✅ EMI SECTION
  {
    key: "emiHeading",
    label: "EMI Section Heading",
    type: "text",
    maxLength: 60
  },
  {
    key: "emiSubtext",
    label: "EMI Subtext",
    type: "text",
    maxLength: 80
  },
  {
    key: "emiButtonText",
    label: "EMI Button Text",
    type: "text",
    maxLength: 30
  },
  {
    key: "emiButtonLink",
    label: "EMI Button Link",
    type: "text"
  },

  // ✅ SAVE WITH PRODUCT (NOW VARIANT-BASED ✅)
  {
    key: "products",
    label: "Product Pricing",
    type: "group",
    repeatable: true,
    fields: [
      {
        key: "variant",
        label: "Variant Name",
        type: "text",
        maxLength: 40
      },
      {
        key: "price",
        label: "Price Text (e.g. ₹11,600 per year)",
        type: "text",
        maxLength: 40
      }
    ]
  },

  // ✅ PRODUCT CARD UI (STATIC PART)
  {
    key: "productHeading",
    label: "Product Section Heading",
    type: "text",
    maxLength: 50
  },
  {
    key: "productImage",
    label: "Product Image",
    type: "image"
  },
  {
    key: "productAlt",
    label: "Product Image Alt",
    type: "text",
    maxLength: 80
  },
  {
    key: "productButtonText",
    label: "CTA Button Text",
    type: "text",
    maxLength: 30
  },
  {
    key: "productButtonLink",
    label: "CTA Button Link",
    type: "text"
  }

],
sectr5: [
      {
        key: "faqs",
        type: "group",
        repeatable: true,
        fields: [
          { key: "question", type: "text", taggable: true },
          { key: "answer", type: "textarea", taggable: true }
        ]
      }
    ]

},
bookNow: {

  // 🔹 1. HERO + TOP BAR SECTION
  secbn1: [
    {
      key: "heading",
      label: "Main Heading",
      type: "text",
      maxLength: 50,
      taggable: true
    },

    {
      key: "bookingText",
      label: "Book at just",
      type: "text",
      maxLength: 40
    },

    {
      key: "bookingPrice",
      label: "Booking Price",
      type: "text",
      //maxLength: 40
    },

    {
      key: "view360Text",
      label: "View 360 Button Text",
      type: "text",
      maxLength: 20
    },

    {
      key: "bulkBookingText",
      label: "Bulk Booking Text",
      type: "text",
      maxLength: 40
    },

    {
      key: "enquireText",
      label: "Enquire Text",
      type: "text",
      maxLength: 20
    },

    {
      key: "enquireLink",
      label: "Enquire Link",
      type: "text"
    }
  ],

  // 🔹 2. STEP TAB SECTION
  secbn2: [
    {
      key: "tabs",
      label: "Step Tabs",
      type: "group",
      repeatable: true,
      limit: 3,
      fields: [
        {
          key: "text",
          label: "Tab Text",
          type: "text",
          maxLength: 30
        }
      ]
    },

    {
      key: "note",
      label: "Top Note Text",
      type: "textarea",
      maxLength: 180
    }
  ],

  // 🔹 3. CITY + VARIANT + COLOUR SECTION
  secbn3: [

    {
      key: "cityPlaceholder",
      label: "City Selection Placeholder",
      type: "text",
      maxLength: 60
    },

    {
      key: "variantHeading",
      label: "Variant Heading",
      type: "text",
      maxLength: 30,
      taggable: true
    },
    {
      key: "colourHeading",
      label: "Colour Heading",
      type: "text",
      maxLength: 30,
      taggable: true
    },

    
  ],

  // 🔹 4. PERSONAL INFO SECTION
  secbn4: [
    {
      key: "heading",
      label: "Personal Info Heading",
      type: "text",
      maxLength: 40,
      taggable: true
    },

    // {
    //   key: "emailLabel",
    //   label: "Email Label",
    //   type: "text",
    //   maxLength: 30
    // },

    // {
    //   key: "fullNameLabel",
    //   label: "Full Name Label",
    //   type: "text",
    //   maxLength: 30
    // },

    // {
    //   key: "phoneLabel",
    //   label: "Phone Number Label",
    //   type: "text",
    //   maxLength: 30
    // },

    {
      key: "phoneNote",
      label: "Phone Helper Note",
      type: "textarea",
      maxLength: 120
    },

    // {
    //   key: "pinCodeLabel",
    //   label: "Pin Code Label",
    //   type: "text",
    //   maxLength: 30
    // }
  ],

  // 🔹 5. SUMMARY SECTION
  secbn5: [
    {
      key: "heading",
      label: "Summary Heading",
      type: "text",
      maxLength: 30,
      taggable: true
    },

    {
      key: "modelLabel",
      label: "Model Label",
      type: "text",
      maxLength: 20
    },

    {
      key: "variantLabel",
      label: "Variant Label",
      type: "text",
      maxLength: 20
    },

    {
      key: "colourLabel",
      label: "Colour Label",
      type: "text",
      maxLength: 20
    },

    {
      key: "modifyText",
      label: "Modify Text",
      type: "text",
      maxLength: 20
    }
  ],
  secbn6: [
    {
      key: "verifyHeading",
      label: "Verify Heading",
      type: "text",
    },
     {
      key: "verifySubtitle",
      label: "Verify Subtitle",
      type: "text",
    },
     {
      key: "verifyStatement",
      label: "verify Statement",
      type: "text",
      maxLength: 50
    }
  ],
  secbn7: [
     {
      key: "confirmHeading",
      label: "Confirm Heading",
      type: "text",
    },
    {
      key: "confirmSubtitle",
      label: "Confirm Subtitle",
      type: "text",
    },
  ]
},

emi: {

  // 🔹 1. HERO SECTION
  secemi1: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 65,
      taggable: true
    },

    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 170
    },

    {
      key: "bannerImage",
      label: "Banner Image",
      type: "image"
    },

    {
      key: "alt",
      label: "Image Alt Text",
      type: "text",
      maxLength: 80
    }
  ],

  // 🔹 2. BENEFITS SECTION
  secemi2: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 40,
      taggable: true
    },

    {
      key: "cards",
      label: "Benefit Cards",
      type: "group",
      repeatable: true,
      limit: 3,
      fields: [
        {
          key: "title",
          label: "Card Title",
          type: "text",
          maxLength: 40
        },

        {
          key: "description",
          label: "Card Description",
          type: "textarea",
          maxLength: 100
        }
      ]
    }
  ],

  // 🔹 3. EMI CALCULATOR SECTION
  secemi3: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 45,
      taggable: true
    },

    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 120
    },

    {
      key: "cityPlaceholder",
      label: "City Dropdown Placeholder",
      type: "text",
      maxLength: 40
    },

    {
      key: "calculatorHeading",
      label: "Calculator Heading",
      type: "text",
      maxLength: 30,
      taggable: true
    }
  ],

  // 🔹 4. CREDIT SCORE SECTION
  secemi4: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 55,
      taggable: true
    },

    {
      key: "subheading",
      label: "Subheading",
      type: "text",
      maxLength: 70
    },

    {
      key: "ranges",
      label: "Credit Score Ranges",
      type: "group",
      repeatable: true,
      limit: 3,
      fields: [
        {
          key: "title",
          label: "Range Title",
          type: "text",
          maxLength: 20
        },

        {
          key: "range",
          label: "Score Range",
          type: "text",
          maxLength: 20
        }
      ]
    },
    {
      key: "statement",
      label: "Finance Partner Statement",
      type: "text",
      maxLength: 60,
      taggable: true
    },
  ],

  

  // 🔹 5. SAVINGS BANNER SECTION
  secemi5: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 40,
      taggable: true
    },

    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 100
    },

    {
      key: "savings",
      label: "Savings Cards",
      type: "group",
      repeatable: true,
      limit: 2,
      fields: [
        {
          key: "value",
          label: "Value",
          type: "text",
          maxLength: 20
        },

        {
          key: "title",
          label: "Title",
          type: "text",
          maxLength: 25
        }
      ]
    }
  ],

  // 🔹 6. OWNERSHIP OPTIONS SECTION
  secemi6: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 45,
      taggable: true
    },

    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 140
    },

    {
      key: "cards",
      label: "Ownership Cards",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "partnerLabel",
          label: "Partner Logo",
          type: "image",
          
        },
         {
          key: "image alt",
          label: "Image alt",
          type: "text",
          
        },

        {
          key: "title",
          label: "Card Title",
          type: "text",
          maxLength: 35
        },

        {
          key: "description",
          label: "Description",
          type: "textarea",
          maxLength: 130
        },

        {
          key: "points",
          label: "Points",
          type: "group",
          repeatable: true,
          fields: [
            {
              key: "text",
              label: "Point",
              type: "text",
              maxLength: 50
            }
          ]
        },

        {
          key: "buttonText",
          label: "Button Text",
          type: "text",
          maxLength: 25
        },

        {
          key: "buttonLink",
          label: "Button Link",
          type: "text"
        }
      ]
    }
  ],

  // 🔹 7. FAQ SECTION
  secemi7: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 55,
      taggable: true
    },
    {
        key: "faqs",
        type: "group",
        repeatable: true,
        fields: [
          { key: "question", type: "text", taggable: true },
          { key: "answer", type: "textarea", taggable: true }
        ]
      }
  ]

},

savings: {

  // 🔹 1. HERO SECTION
  secsav1: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 60,
      taggable: true
    },

    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 180
    },

    {
      key: "stats",
      label: "Statistics Cards",
      type: "group",
      repeatable: true,
      limit: 3,
      fields: [
        {
          key: "value",
          label: "Value",
          type: "text",
          maxLength: 20
        },
        {
          key: "description",
          label: "Description",
          type: "textarea",
          maxLength: 80
        }
      ]
    },
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 60,
      taggable: true
    },

    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 220
    },

    {
      key: "metrics",
      label: "Performance Metrics",
      type: "group",
      repeatable: true,
      limit: 4,
      fields: [
        {
          key: "value",
          label: "Metric Value",
          type: "text",
          maxLength: 20
        },
        {
          key: "label",
          label: "Metric Label",
          type: "text",
          maxLength: 40
        }
      ]
    }
  ],

  // 🔹 2. SAVINGS CALCULATOR SECTION
  secsav2: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 50,
      taggable: true
    },

    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 120
    },
     {
      key: "Petrol Price",
      label: "Petrol Price",
      type: "text",
    },
     {
      key: "cards",
      label: "Savings Highlight Cards",
      type: "group",
      repeatable: true,
      fields: [
       

        {
          key: "description",
          label: "Description",
          type: "text",
          maxLength: 60
        }
      ]
    }

  ],

 

  // 🔹 3. MYTHS SECTION
  secsav3: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 50,
      taggable: true
    },

    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 120
    },

    {
      key: "faqs",
      label: "Myths",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "question",
          label: "Question",
          type: "text",
          maxLength: 120
        },

        {
          key: "answer",
          label: "Answer",
          type: "textarea",
          maxLength: 300
        }
      ]
    }
  ],

  // 🔹 4. TESTIMONIALS
  secsav4: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 50,
      taggable: true
    },

   

    {
      key: "testimonials",
      label: "Testimonials",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "contentType",
          label: "Content Type",
          type: "select",
          options: [
             { label: "Video", value: "video" },
        { label: "Text", value: "text" }
          ]
        },

        {
      key: "video",
      label: "Video",
      type: "video",
      condition: {
        field: "contentType",
        value: "video"
      }
    },

    {
      key: "description",
      label: "Description",
      type: "textarea",
      maxLength: 250,
      condition: {
        field: "contentType",
        value: "text"
      }
    },

        {
          key: "name",
          label: "Name",
          type: "text",
          maxLength: 60
        }
      ]
    }
  ],
  // 🔹 5. WHAT YOUR SAVINGS BUY
  secsav5: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 60,
      taggable: true
    },

    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 140
    },

    {
      key: "cards",
      label: "Savings Purchase Cards",
      type: "group",
      repeatable: true,
      limit: 3,
      fields: [
        {
          key: "title",
          label: "Title",
          type: "text",
          maxLength: 60
        },

        {
          key: "description",
          label: "Description",
          type: "textarea",
          maxLength: 180
        },

        {
          key: "savingText",
          label: "Saving Text",
          type: "text",
          maxLength: 80
        }
      ]
    }
  ],

  // 🔹 6. PLANET IMPACT SECTION
  secsav6: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 60,
      taggable: true
    },

    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 120
    },

    {
      key: "cards",
      label: "Impact Cards",
      type: "group",
      repeatable: true,
      limit: 4,
      fields: [
        {
          key: "image",
          label: "Image",
          type: "image"
        },

        {
          key: "alt",
          label: "Image Alt",
          type: "text",
          maxLength: 80
        },

        {
          key: "value",
          label: "Value",
          type: "text",
          maxLength: 20
        },

        {
          key: "description",
          label: "Description",
          type: "text",
          maxLength: 80
        }
      ]
    }
  ]

},

login: {

  // 🔹 DASHBOARD CONTENT SECTION
  seclog1: [

    // WHAT'S NEXT
    {
      key: "nextHeading",
      label: "What's Next Heading",
      type: "text",
      maxLength: 40,
      taggable: true
    },

    {
      key: "nextCards",
      label: "What's Next Cards",
      type: "group",
      repeatable: true,
      limit: 3,
      fields: [
        {
          key: "title",
          label: "Card Title",
          type: "text",
          maxLength: 40
        },

        {
          key: "description",
          label: "Description",
          type: "textarea",
          maxLength: 150
        },

        {
          key: "buttonText",
          label: "Button Text",
          type: "text",
          maxLength: 30
        },

        {
          key: "buttonLink",
          label: "Button Link",
          type: "text"
        }
      ]
    },

    // ACCESSORIES SECTION
    {
      key: "accessoriesHeading",
      label: "Accessories Heading",
      type: "text",
      maxLength: 60,
      taggable: true
    },

    {
      key: "accessoriesSubheading",
      label: "Accessories Subheading",
      type: "textarea",
      maxLength: 200
    },

    {
      key: "accessories",
      label: "Accessory Cards",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "image",
          label: "Image",
          type: "image"
        },

        {
          key: "alt",
          label: "Image Alt",
          type: "text",
          maxLength: 80
        },

        {
          key: "title",
          label: "Title",
          type: "text",
          maxLength: 40
        },

        {
          key: "buttonText",
          label: "Button Text",
          type: "text",
          maxLength: 25
        },

        {
          key: "buttonLink",
          label: "Button Link",
          type: "text"
        }
      ]
    },

    {
      key: "shopButtonText",
      label: "Shop Accessories Button Text",
      type: "text",
      maxLength: 30
    },

    {
      key: "shopButtonLink",
      label: "Shop Accessories Button Link",
      type: "text"
    },

    // FAQ SECTION
    {
      key: "faqHeading",
      label: "FAQ Heading",
      type: "text",
      maxLength: 60,
      taggable: true
    },

    {
      key: "faqs",
      label: "FAQs",
      type: "group",
      repeatable: true,
      fields: [
        {
          key: "question",
          label: "Question",
          type: "text",
          maxLength: 150
        },

        {
          key: "answer",
          label: "Answer",
          type: "textarea",
          maxLength: 500
        }
      ]
    }

  ],
  seclog2: [
     {
      key: "loginHeading",
      label: "Login Page Heading",
      type: "text",
      maxLength: 40,
      taggable: true
    },
      {
      key: "loginSubHeading",
      label: "Login Page Sub Heading",
      type: "text",
      maxLength: 40,
      //taggable: true
    },
    {
      key: "FieldText",
      label: "Input Field Text",
      type: "text",
      maxLength: 40,
      //taggable: true
    },

  ],
  seclog3: [
     {
      key: "OtpHeading",
      label: "Otp Page Heading",
      type: "text",
      maxLength: 40,
      taggable: true
    },
    {
      key: "FieldText",
      label: "Otp Field Text",
      type: "text",
      maxLength: 40,
      //taggable: true
    },
      {
      key: "modifyButtonText",
      label: "Modify Button Text",
      type: "text",
      //maxLength: 30
    },

    {
      key: "resendButtonText",
      label: "Resend Otp Button Text",
      type: "text"
    },
  ]
},
blogs: {

  // 🔹 1. FEATURED BLOGS SECTION
  secblog1: [
    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 50,
      taggable: true
    },

   
  ],

  // 🔹 2. NEWSLETTER SECTION
  secblog2: [

    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 50,
      taggable: true
    },

    {
      key: "description",
      label: "Description",
      type: "textarea",
      maxLength: 220
    },

    {
      key: "buttonText",
      label: "Button Text",
      type: "text",
      maxLength: 25
    }

  ]

},

commonTestRide: {

  // 🔹 1. CHOOSE MODEL SECTION
  secctr1: [

    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 60,
      taggable: true
    },

    {
      key: "cards",
      label: "Vehicle Cards",
      type: "group",
      repeatable: true,
      limit: 2,
      fields: [

        {
          key: "vehicle",
          label: "Vehicle",
          //type: "vehicle"
        },

        {
          key: "image",
          label: "Vehicle Image",
          type: "image"
        },

        {
          key: "imageAlt",
          label: "Image Alt",
          type: "text",
          maxLength: 80
        },

        {
          key: "tagline",
          label: "Tagline",
          type: "text",
          maxLength: 80
        },

       

        {
          key: "testRideButton",
          label: "Test Ride Button Text",
          type: "text",
          maxLength: 20
        },

        {
          key: "learnMoreButton",
          label: "Learn More Button Text",
          type: "text",
          maxLength: 20
        }
      ]
    }

  ],

  // 🔹 2. STILL NOT SURE CTA
  secctr2: [

    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 40,
      taggable: true
    },

    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 120
    },

    {
      key: "buttonText",
      label: "Button Text",
      type: "text",
      maxLength: 25
    },

    {
      key: "buttonLink",
      label: "Button Link",
      type: "text"
    }

  ]

},
commonBookNow: {

  // 🔹 1. CHOOSE MODEL SECTION
  seccbn1: [

    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 60,
      taggable: true
    },

    {
      key: "cards",
      label: "Vehicle Cards",
      type: "group",
      repeatable: true,
      limit: 2,
      fields: [

        {
          key: "vehicle",
          label: "Vehicle",
          //type: "vehicle"
        },

        {
          key: "image",
          label: "Vehicle Image",
          type: "image"
        },

        {
          key: "imageAlt",
          label: "Image Alt",
          type: "text",
          maxLength: 80
        },

        {
          key: "tagline",
          label: "Tagline",
          type: "text",
          maxLength: 80
        },

       

        {
          key: "Book Now Button",
          label: "Button Text",
          type: "text",
          maxLength: 20
        },

        {
          key: "learnMoreButton",
          label: "Learn More Button Text",
          type: "text",
          maxLength: 20
        }
      ]
    }

  ],

  // 🔹 2. STILL NOT SURE CTA
  seccbn2: [

    {
      key: "heading",
      label: "Heading",
      type: "text",
      maxLength: 40,
      taggable: true
    },

    {
      key: "subheading",
      label: "Subheading",
      type: "textarea",
      maxLength: 120
    },

    {
      key: "buttonText",
      label: "Button Text",
      type: "text",
      maxLength: 25
    },

    {
      key: "buttonLink",
      label: "Button Link",
      type: "text"
    }

  ]

},

 diplos: {

  // 🔹 1. HERO SECTION
  secd1: [
    {
      key: "bannerImage",
      label: "Banner Image",
      type: "image"
    },
    {
      key: "alt",
      label: "Image Alt",
      type: "text",
      maxLength: 80
    }
  ],

  // 🔹 2. VEHICLE OVERVIEW
  secd2: [
     {
      key: "logoImage",
      label: "logo Image",
      type: "image"
    },
    {
      key: "alt",
      label: "Diplos Image Alt",
      type: "text",
      maxLength: 30
    },
    {
      key: "mainheading",
      label: "Main Heading",
      type: "text",
      maxLength: 60,
      taggable: true
    },
      {
      key: "metrics",
      label: "Metrics",
      type: "group",
      repeatable: true,
      limit: 3,
      fields: [
        { key: "value", label: "Value", type: "text", maxLength: 10 },
        { key: "title", label: "Title", type: "text", maxLength: 30 }
      ]
    },
    { key: "buttonText", label: "Button Text", type: "text", maxLength: 30 },
    { key: "buttonLink", label: "Button Link", type: "text" },
     { key: "heading", label: "Heading", type: "text", maxLength: 180, taggable: true },
    { key: "subheading", label: "Subheading", type: "textarea", maxLength: 50 },
   
  ],

  // 🔹 3. MAX STRENGTH
  secd3: [
    //  {
    //   key: "description",
    //   label: "Description",
    //   type: "textarea",
    //   maxLength: 250
    // },
    // {
    //   key: "highlight",
    //   label: "Highlight Text",
    //   type: "text",
    //   maxLength: 80
    // },
    {
      key: "video",
      label: "Video",
      type: "video"
    },
     { key: "alt", label: "Video Alt Text", type: "text", maxLength: 80 }
  ],

  secd4: [
    {
      key: "tabs",
      label: "Tab Names",
      type: "group",
      repeatable: true,
      limit: 8,
      fields: [
        { key: "name", label: "Tab Name", type: "text", maxLength: 40 }
      ]
    }
  ],

  secd5:[
    {
      key: "heading",
      type: "text",
      taggable: true
    },
    {
      key: "description",
      type: "textarea",
      maxLength: 180
    },
    {
      key: "cards",
      type: "group",
      repeatable: true,
      limit: 6,
      fields: [
        {
          key: "image",
          type: "image"
        },
        {
          key: "alt",
          type: "text",
          maxLength: 80
        },
        {
          key: "title",
          type: "text",
          maxLength: 50
        },
        {
          key: "description",
          type: "textarea",
          maxLength: 120
        }
      ]
    },
      {
      key: "maxStrengthImage",
      label: "Max Strength Banner Image",
      type: "image"
    },
    {
      key: "maxalt",
      label: "Max Strength Banner Image Alt",
      type: "text",
     
    },
  ],

  // 🔹 6. MAX SAFETY
  secd6: [
    {
      key: "heading",
      type: "text",
      taggable: true
    },
    {
      key: "subheading",
      type: "textarea",
      maxLength: 180
    },
    {
      key: "maxSafetyImage",
      label: "Max Safety Banner Image",
      type: "image"
    },
    {
      key: "maxsafetyalt",
      label: "Max Safety Banner Image Alt",
      type: "text",
     
    },
    {
      key: "title",
      label: "Max Safety Image Title",
      type: "text",
     
    },
    {
      key: "description",
      label: "Max Safety Image Description",
      type: "textarea",
      maxLength: 180
    },
    {
      key: "cards",
      type: "group",
      repeatable: true,
      limit: 6,
      fields: [
        {
          key: "image",
          type: "image"
        },
        {
          key: "alt",
          type: "text",
          maxLength: 80
        },
        {
          key: "title",
          type: "text",
          maxLength: 50
        },
        {
          key: "description",
          type: "textarea",
          maxLength: 120
        }
      ]
    }
  ],

  // 🔹 7. MAX CONTROL
  secd7: [
    {
      key: "heading",
      type: "text",
      taggable: true
    },
    {
      key: "description",
      type: "textarea",
      maxLength: 180
    },
    {
      key: "cards",
      type: "group",
      repeatable: true,
      limit: 6,
      fields: [
        {
          key: "image",
          type: "image"
        },
        {
          key: "alt",
          type: "text",
          maxLength: 80
        },
        {
          key: "title",
          type: "text",
          maxLength: 50
        },
        {
          key: "description",
          type: "textarea",
          maxLength: 120
        }
      ]
    },
    {
      key: "maxControlbannerImage",
      label: "Bottom Banner",
      type: "image"
    },
    {
      key: "maxControlbannerAlt",
      label: "Banner Alt",
      type: "text",
      maxLength: 80
    }
  ],

  
  // 🔹 8. COLOR + IMAGE PICKER
  secd8: [
    {
      key: "colorOptions",
      label: "Color Options",
      type: "group",
      repeatable: true,
      limit: 4,
      fields: [
        { key: "image", label: "Image", type: "image" },
        { key: "color", label: "Color", type: "color" },
        { key: "colorName", label: "Color Name", type: "text", maxLength: 30 }
      ]
    }
  ],

  // 🔹 9. CHOOSE YOUR DIPLOS
  // Vehicle cards come from Vehicles tables
  secd9: [
    {
      key: "heading",
      type: "text",
      taggable: true
    },
    {
      key: "subheading",
      type: "text",
      maxLength: 60
    },
    { key: "brochure", label: "Download Brochure (PDF)", type: "file" },
      {
      key: "products",
      label: "Product Variants",
      type: "group",
      repeatable: true,
      limit: 3,
      fields: [
        { key: "image", label: "Product Image", type: "image" },
        { key: "variantName", label: "Variant Name", type: "text", maxLength: 40 },
        { key: "price", label: "Price", type: "text", maxLength: 20 },
        { key: "ridingMode", label: "Riding Mode Value", type: "text", maxLength: 30 },
        { key: "batteryCapacity", label: "Battery Capacity Value", type: "text", maxLength: 20 },
        { key: "motorPeakPower", label: "Motor Peak Power Value", type: "text", maxLength: 20 },
        { key: "idcRange", label: "IDC Range Value", type: "text", maxLength: 20 },
        { key: "topSpeed", label: "Top Speed Value", type: "text", maxLength: 20 },
        { key: "groundClearance", label: "Ground Clearance Value", type: "text", maxLength: 20 },

        {
          key: "colors",
          label: "Colors",
          type: "group",
          repeatable: true,
          limit: 4,
          fields: [
            { key: "colorName", label: "Color Name", type: "text", maxLength: 30 },
            { key: "color", label: "Color", type: "color" },
          ]
        },

        
      ]
    }
  ],

  // 🔹 10. SAVINGS SECTION
  // Calculator is dynamic
  secd10: [
    {
      key: "heading",
      type: "text",
      taggable: true
    }
  ]

}


};

module.exports = sectionSchema;

